module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 62.44 66.67\"><title>Testimonial</title><g id=\"f70af607-21fd-449f-baca-1f6be75fd474\" data-name=\"Layer 2\"><g id=\"0e5a1d8d-4413-4557-9a85-6bafc11dd3df\" data-name=\"Layer 1\"><circle cx=\"31.22\" cy=\"17.56\" r=\"17.56\"></circle><path d=\"M-537.56-633.33v-6.18A19.57,19.57,0,0,0-557.07-659h-23.42A19.57,19.57,0,0,0-600-639.51v6.18Z\" transform=\"translate(600 700)\"></path></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/testimonial.svg
// module id = izrt
// module chunks = 2